const RICOS_VERSION = "11.6.6";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
